export const REPORTS_SHARING_PATH_PREFIX = '/reports';
export const REPORTS_LIST_PATH = `${REPORTS_SHARING_PATH_PREFIX}/:reportTermPath/:reportTypePath`;
export const REPORT_DETAIL_PAGE_PATH = `${REPORTS_SHARING_PATH_PREFIX}/:reportTermPath/:reportTypePath/:reportId`;
